import { IAppState } from 'models/store.model'
import {
  selectCurrency,
  selectSubscriptionCurrentPrice,
  selectSubscriptionPeriodName,
  selectSubscriptionPeriodQuantity,
  selectSubscriptionPriceId,
  selectSubscriptionTrialPeriodPrice,
} from 'modules/purchase/redux/selects'
import { selectScreenName } from 'root-redux/selects/common'
import { createProductId } from 'helpers/createProductId'
import { selectUUID } from 'root-redux/selects/user'

export const getStripePurchaseCommonEventParams = (state: IAppState) => {
  const uuid = selectUUID(state)
  const stripePriceId = selectSubscriptionPriceId(state)
  const currentPrice = selectSubscriptionCurrentPrice(state)
  const trialPeriodPrice = selectSubscriptionTrialPeriodPrice(state)
  const periodName = selectSubscriptionPeriodName(state)
  const periodQuantity = selectSubscriptionPeriodQuantity(state)
  const currency = selectCurrency(state)
  const screenName = selectScreenName(state)

  const productId = createProductId({
    periodName,
    periodQuantity,
    price: trialPeriodPrice || currentPrice,
  })

  return {
    uuid,
    currentPrice,
    trialPeriodPrice,
    periodName,
    periodQuantity,
    currency,
    screenName,
    productId,
    stripePriceId,
  }
}
